import {FormControl,FormLabel,Input, Divider,  Button, ButtonGroup , Flex, Box,  Tooltip, useToast } from '@chakra-ui/react'
import { MdPerson } from 'react-icons/md';
import { useForm } from "react-hook-form";
import { useState } from 'react';
import OsobaSelect from '../osoba/OsobaSelect';
import LokacijaFarmaDefaultSelect from '../lokacija/LokacijaFarmaDefaultSelect';
import AdresaHr from '../custom/AdresaHr';




const KnjigaView = ({knjiga, readonly,onCancel,onSave,size='xs'}) => {
    const [state,setState]=useState({showpos:false,showvl:false,knjiga:knjiga,err:""});
    const { register, handleSubmit, formState: { errors } } = useForm();
    const toast=useToast();
    const onSubmit = (data, event) => {
        event.preventDefault();
        let errmsg="";
        if (state.knjiga.posjednik_id===undefined) {
            errmsg="Morate odabrati posjednika";
        } else if (state.knjiga.vlasnik_id===undefined) {
            errmsg="Morate odabrati vlasnika";
        } else if (state.knjiga.odjeljak_id===undefined) {
            errmsg="Morate odabrati zadanu lokaciju";
        }
        if (errmsg!=="") {
            setState({...state,err:errmsg});
        } else {
            //dodati jibg, ikg, naziv
            //setState({...state,knjiga:{...state.knjiga,naziv:data.naziv,jibg:data.jibg.toUpperCase(),ikg:data.ikg}});
            let _knjiga=state.knjiga;
            _knjiga.naziv=data.naziv;
            _knjiga.jibg=data.jibg.toUpperCase();
            _knjiga.ikg=data.ikg;
            _knjiga.povrsina=data.povrsina;
            _knjiga.datupisregistar=data.datupisregistar;
            onSave(_knjiga);
        }
        
    }

    const PreventEnter=(e)=>{
        e.keyCode===13 && e.preventDefault();
    }

    const ShowErr=()=>{
        if (state.err!=="") {
            toast({
                title:"Greška u podacima.",
                status:"error",
                description:state.err,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
            setState({...state,err:""})
        }
    }

    const setPosjednik=({id,adresa,naziv, posta, sifra})=>{
        setState({...state,showpos:false,knjiga:{...state.knjiga,posjednik_id:id, posjednik_adresa:adresa,posjednik_naziv:naziv,posjednik_posta:posta,posjednik_sifra:sifra}});
    }
    const ShowPosjednike=()=>{
        if (state.showpos) {
            return (
                <OsobaSelect naslov="Posjednici" onClose={(e)=>setState({...state,showpos:false})} onSelect={(osoba)=>setPosjednik(osoba)}/>
            )
        }
        else {
            return (
                <>
                <Flex direction={'row'} gap={'1rem'}>
                    <Flex direction={'column'} w={'20%'}>
                    <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} variant={'outline'} placeholder={'Šifra'} defaultValue={state.knjiga.posjednik_sifra} readOnly={true}></Input>        
                    </Flex>
                    
                    <Flex direction={'column'} w={'80%'}>
                        <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} variant={'outline'} placeholder={'Naziv'} defaultValue={state.knjiga.posjednik_naziv} readOnly={true}></Input>
                    </Flex>
                </Flex>
                <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} variant={'outline'} placeholder={'Adresa'} defaultValue={state.knjiga.posjednik_adresa} readOnly={true}></Input>
                 <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} variant={'outline'} placeholder={'Pošta'} defaultValue={state.knjiga.posjednik_posta} readOnly={true}></Input>
                 </>
            )
        }
    }
    const setVlasnik=({id,adresa,naziv, posta, sifra})=>{
        setState({...state,showvl:false,knjiga:{...state.knjiga,vlasnik_id:id, vlasnik_adresa:adresa,vlasnik_naziv:naziv,vlasnik_posta:posta,vlasnik_sifra:sifra}});
    }

    const ShowVlasnike=()=>{
        if (state.showvl) {
            return (
                <OsobaSelect naslov="Vlasnici" onClose={(e)=>setState({...state,showvl:false})} onSelect={(osoba)=>setVlasnik(osoba)}/>
            )
        }
        else {
            return (
                <>
                <Flex direction={'row'} gap={'1rem'}>
                    {ShowErr()}
                    <Flex direction={'column'} w={'20%'}>
                    <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} variant={'outline'} placeholder={'Šifra'}  defaultValue={state.knjiga.vlasnik_sifra} readOnly={true}></Input>        
                    </Flex>
                    
                    <Flex direction={'column'} w={'80%'}>
                        <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} variant={'outline'} placeholder={'Naziv'} defaultValue={state.knjiga.vlasnik_naziv} readOnly={true}></Input>
                    </Flex>
                </Flex>
                <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} variant={'outline'} placeholder={'Adresa'} defaultValue={state.knjiga.vlasnik_adresa} readOnly={true}></Input>
                <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} variant={'outline'} placeholder={'Pošta'} defaultValue={state.knjiga.vlasnik_posta} readOnly={true}></Input>
                 </>
            )
        }
    }

    const onKnjigaAdresaChange=(adr)=>{
        setState({...state,knjiga:{...state.knjiga,mjesto:adr.mj,ulkbr:adr.ulkbr,pbr:adr.pbr,post:adr.pst,opcina:adr.opc,zupanija:adr.zup}});
    }

    return (
        <Flex direction={'column'} scrollBehavior={'auto'}>
            <form onSubmit={handleSubmit(onSubmit)}>
            <FormControl  onKeyDown={PreventEnter} isReadOnly={readonly}>
                <Flex direction={'row'} gap={'0.5rem'}>
                <Flex direction={'column'} w={'50%'}>
                    <FormLabel fontSize={size}>Naziv</FormLabel>
                    <Tooltip hasArrow label='Polje je obavezno' bg='red' color='white'  isDisabled={!errors.naziv}>
                        <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} variant={'filled'}  maxLength={30} defaultValue={state.knjiga.naziv} {...register("naziv",{required:true})}></Input>
                    </Tooltip>
                </Flex>
                <Flex direction={'column'} w={'50%'}>
                    <FormLabel fontSize={size}>Lokacija farme</FormLabel>
                    {/* <OdjeljakSelect readonly={readonly} naslov="Zadana lokacija" selected={state.knjiga.odjeljak_id} onSelect={(id)=>setState({...state,knjiga:{...state.knjiga,odjeljak_id:id}})}/> */}
                    <LokacijaFarmaDefaultSelect  readonly={readonly} naslov="Lokacija farme" selected={state.knjiga.odjeljak_id} onSelect={(id)=>setState({...state,knjiga:{...state.knjiga,odjeljak_id:id}})} />
                </Flex>
                </Flex>

                
                <Flex direction={'row'} gap={'0.5rem'}>
                    <Flex direction={'column'} w={'50%'}>
                        <FormLabel fontSize={size}>JIBG</FormLabel>
                        <Tooltip hasArrow label='JIBG mora imati format HR 12345678/HU 12345678' bg='red' color='white'  isDisabled={!errors.jibg}>
                            <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} maxLength={11} variant={'filled'} autoCapitalize={'on'} defaultValue={state.knjiga.jibg}  {...register("jibg",{required:true, pattern:/(^(HR|HU) [0-9]{8}$|^$)/i})}></Input>
                        </Tooltip>
                    </Flex>
                    
                    <Flex direction={'column'} w={'50%'}>
                        <FormLabel fontSize={size}>IKG</FormLabel>
                        <Tooltip hasArrow label='Polje je obavezno (sastoji se od 8 znamenki)' bg='red' color='white'  isDisabled={!errors.ikg}>
                            <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} maxLength={8} variant={'filled'} autoCapitalize={'on'} defaultValue={state.knjiga.ikg}  {...register("ikg",{required:true, pattern:/(^[0-9]{8}$|^$)/i})}></Input>
                        </Tooltip>
                    </Flex>
                </Flex>
                <Box>
                    <AdresaHr onChange={onKnjigaAdresaChange}  size='xs' mjesto={knjiga.mjesto} ulkbr={knjiga.ulkbr} pbr={knjiga.pbr} posta={knjiga.posta} opcina={knjiga.opcina} zupanija={knjiga.zupanija} readonly={readonly}/>
                </Box>
                <Divider orientation={'horizontal'} m={'0.5rem'}/>
                {readonly?<FormLabel>Posjednik</FormLabel>:<Button rightIcon={<MdPerson/>} colorScheme={'grunt2'} variant={'outline'} size={size} mb={'0.5rem'} onClick={(e)=>setState({...state,showpos:true})}>Posjednik</Button>}
                
                {ShowPosjednike()}
                
                 <Divider orientation={'horizontal'} m={'0.5rem'}/>
                 {readonly?<FormLabel>Vlasnik</FormLabel>:<Button rightIcon={<MdPerson/>} variant={'outline'} colorScheme={'grunt2'} size={size} mb={'0.5rem'} onClick={(e)=>setState({...state,showvl:true})}>Vlasnik</Button>} 
                
                {ShowVlasnike()}
                
                <Divider orientation={'horizontal'} m={'0.5rem'}/>

                <Flex direction={'row'} gap={'1rem'}>
                    <Flex direction={'column'} w={'50%'}>
                        <FormLabel fontSize={size}>Površina (m²)</FormLabel>
                        <Tooltip hasArrow label='Upisati broj bez decimalne točke.' bg='red' color='white'  isDisabled={!errors.povrsina}>
                            <Input focusBorderColor='grunt2.400' size={size} mb={'0.5rem'} maxLength={9} variant={'filled'} autoCapitalize={'on'} defaultValue={state.knjiga.povrsina}  {...register("povrsina",{required:true, pattern:/(^\d{1,9}$)/i})}></Input>
                        </Tooltip>
                    </Flex>
                    
                    <Flex direction={'column'} w={'50%'}>
                        <FormLabel fontSize={size}>Datum upisa u registar</FormLabel>
                        <Input focusBorderColor='grunt2.400' size={size} id="idDatum"   type="date" variant={'filled'}   defaultValue={state.knjiga.datupisregistar}  {...register("datupisregistar",{required:true})}></Input>
                    </Flex>
                </Flex>
                <Divider orientation={'horizontal'} m={'0.5rem'}/>
                <ButtonGroup gap={'2rem'}>
                    {readonly?<></>:<Button type={'submit'} colorScheme={'grunt2'} size={size}>Spremi</Button>}
                    <Button colorScheme={'grunt2'} variant={'outline'} size={size} onClick={onCancel}>Odustani</Button>
                 </ButtonGroup>
            </FormControl>
            </form>
        </Flex>
    );
}

export default KnjigaView;
